import * as DiagnosticTypes from "./services/diagnosticTypes/index.js";
import * as ScheduleVisit from "./services/VisitTypes/index.js";
import * as ScheduleTable from "./services/scheduleTable/index.js";
export {DiagnosticTypes};
export {ScheduleVisit};
export {ScheduleTable};